import { render, staticRenderFns } from "./LivingOptionSubsections.vue?vue&type=template&id=2d504904&scoped=true&"
import script from "./LivingOptionSubsections.vue?vue&type=script&lang=js&"
export * from "./LivingOptionSubsections.vue?vue&type=script&lang=js&"
import style0 from "./LivingOptionSubsections.vue?vue&type=style&index=0&id=2d504904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d504904",
  null
  
)

export default component.exports